import React from 'react';
import type { StaticKpi } from '../types';

function fmtCurrency(v: number) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(v || 0);
}
function fmtNumber(v: number) {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(v || 0);
}
function fmtPct(v: number) {
  return `${(v || 0).toFixed(1)}%`;
}

export default function StaticKpiCard({ kpi }: { kpi: StaticKpi }) {
  const renderValue = () => {
    if (kpi.kpiType === 'text') return kpi.valueText;
    const n = Number(kpi.valueText);
    if (!Number.isFinite(n)) return kpi.valueText;
    if (kpi.kpiType === 'currency') return fmtCurrency(n);
    if (kpi.kpiType === 'percentage') return fmtPct(n);
    if (kpi.kpiType === 'days') return fmtNumber(n);
    return fmtNumber(n);
  };

  return (
    <div className="card">
      <h3>{kpi.title}</h3>
      <div className="metric">{renderValue()}</div>
      {kpi.description ? <div className="sub">{kpi.description}</div> : null}
    </div>
  );
}
